import { SanityImageSource } from '@sanity/image-url/lib/types/types'

import { SanityImage } from 'src/components/atoms/SanityImage'
import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'

// Figma node 63:6298. Lavender forest-pattern band (`patternLavenderSoft` +
// `lavenderBright/50` overlay — #d8aaf3 = lavenderBright). Text uses the spec's
// #1d4321 (old forestDeep) → forestDeep token.
type PostHeroRebrandProps = {
  title: string
  eyebrow?: string
  postDate?: string | null
  readingTime: string
  imageUrl: SanityImageSource | undefined
}

export const PostHeroRebrand = ({
  title,
  eyebrow = 'News',
  postDate,
  readingTime,
  imageUrl
}: PostHeroRebrandProps) => {
  return (
    <section>
      <div className='relative overflow-hidden'>
        <div
          aria-hidden
          className='absolute inset-0 bg-cover bg-center'
          style={{
            backgroundImage: "url('/img/hero/patterns/article_bg_option_1.png')"
          }}
        />
        {/* `hero-rebrand-post unified` opts into the existing unified blend: the
            header's `:has(+ main [class*='hero-rebrand-'].unified)` rule (hero.css)
            makes it transparent/absolute over the hero, and `unified` adds pt-25
            to clear it. Nav links use their default color over the lavender. */}
        <div className='hero-rebrand-post unified relative container mx-auto px-4 pb-28 lg:px-20 lg:pb-48'>
          <div className='flex max-w-[880px] flex-col gap-6 pt-20 lg:pt-36'>
            <TypographyRebrand variant='eyebrow' color='forestDeep'>
              {eyebrow}
            </TypographyRebrand>
            {/* Spec TTC-H2: ES Rebond Extrabold 48px uppercase — matches
                typography-rebrand-h2 + strong. Rendered as the post's main
                heading at the design's H2 scale. */}
            <TypographyRebrand variant='h2' color='forestDeep'>
              <strong>{title}</strong>
            </TypographyRebrand>
            <TypographyRebrand variant='paragraph' color='forestDeep'>
              {postDate ? `${postDate} | ${readingTime}` : readingTime}
            </TypographyRebrand>
          </div>
        </div>
      </div>

      {imageUrl && (
        <div className='px-4 md:px-20 relative z-10 container mx-auto -mt-20 lg:-mt-36'>
          <SanityImage
            source={imageUrl}
            width={1086}
            height={590}
            alt={title}
            className='aspect-[1086/590] w-full object-cover'
          />
        </div>
      )}
    </section>
  )
}

export default PostHeroRebrand
